import React from "react";
import { Paper, TextField, Grid, Button } from "@mui/material";
import { useFormik } from "formik";

const PopperBot = ({ botItem = null, handleEdit }) => {
    // console.log("Popper");
    const onSubmit = () => {
        // console.log(formik.values);
        handleEdit(formik.values);
    };
    const formik = useFormik({
        initialValues: botItem || {
            id: 0,
            name: "",
            price: 0.0,
            decimal: 4,
            decimal_qty: 1,
            buyQty: 0,
            brokerage: 0.0042,
            interval: 0.02,
            profit: 0.022,
        },
        onSubmit: onSubmit,
    });
    return (
        <>
            <Paper
                sx={{
                    width: 600,
                    height: 150,
                    padding: "10px",
                }}
                elevation={5}
            >
                <form onSubmit={formik.handleSubmit}>
                    <Grid container spacing={1}>
                        <Grid item xs={3}>
                            <TextField
                                name="id"
                                value={formik.values.id}
                                sx={{ display: "none" }}
                            />
                            <TextField
                                size="small"
                                name="name"
                                value={formik.values.name}
                                label="Crypto"
                                fullWidth
                                onChange={formik.handleChange}
                                required
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                size="small"
                                name="price"
                                value={formik.values.price}
                                label="Start Price"
                                fullWidth
                                type="number"
                                inputProps={{ step: 0.0001 }}
                                onChange={formik.handleChange}
                                required
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                size="small"
                                name="decimal"
                                value={formik.values.decimal}
                                label="Decimal"
                                fullWidth
                                type="number"
                                inputProps={{ step: 1 }}
                                onChange={formik.handleChange}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                size="small"
                                name="decimal_qty"
                                value={formik.values.decimal_qty}
                                label="Dec_Qty"
                                fullWidth
                                type="number"
                                inputProps={{ step: 1 }}
                                onChange={formik.handleChange}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                size="small"
                                name="buyQty"
                                value={formik.values.buyQty}
                                label="Buy Qty"
                                fullWidth
                                type="number"
                                inputProps={{ step: 0.1 }}
                                onChange={formik.handleChange}
                                required
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                size="small"
                                name="brokerage"
                                value={formik.values.brokerage}
                                label="Brokeage"
                                fullWidth
                                type="number"
                                inputProps={{ step: 0.0001 }}
                                onChange={formik.handleChange}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                size="small"
                                name="interval"
                                value={formik.values.interval}
                                label="Interval"
                                fullWidth
                                type="number"
                                inputProps={{ step: 0.001 }}
                                onChange={formik.handleChange}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                size="small"
                                name="profit"
                                value={formik.values.profit}
                                label="Profit"
                                fullWidth
                                type="number"
                                inputProps={{ step: 0.001 }}
                                onChange={formik.handleChange}
                            />
                        </Grid>

                        <Grid item xs></Grid>
                        <Grid item xs={2}>
                            <Button variant="contained" type="submit">
                                Save
                            </Button>
                        </Grid>
                        <Grid item xs></Grid>
                    </Grid>
                </form>
            </Paper>
        </>
    );
};

export default PopperBot;
